<template>
    <div>
        <v-range-slider
            v-model="range"
            hide-details
            color="teal lighten-2"
            :label="componentLabel"
            :max="max"
            :min="min"
            @end="change"
        ></v-range-slider>
        <v-row>
            <v-col cols="6" v-for="key in 2" :key="key">
                <v-text-field
                    :value="range[key - 1]"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    @change="textPriceChange($event, key - 1)"
                ></v-text-field>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: 'FilterPrice',
        model: {
            prop: 'value',
            event: 'change',
        },
        props: {
            value: {
                required: false,
                type: Array,
                default: () => [],
            },
            label: {
                required: false,
                type: String,
            },
            min: {
                required: false,
                type: Number,
                default: 0,
            },
            max: {
                required: false,
                type: Number,
                default: 10000,
            },
        },
        data() {
            return {
                range: [this.min, this.max],
            }
        },
        computed: {
            componentLabel() {
                return this.label || this.$t('price');
            },
        },
        methods: {
            textPriceChange(e, key) {
                if (e >= this.min && e <= this.max) {
                    this.$set(this.range, key, e);
                    this.change();
                }
            },
            change() {
                this.$emit('change', this.range);
            },
        },
        watch: {
            value: {
                handler(value) {
                    if (value.length) {
                        this.range = value;
                    }
                },
                deep: true,
            },
            min(value) {
                if (!this.value.length) {
                    this.$set(this.range, 0, value);
                }
            },
            max(value) {
                if (!this.value.length) {
                    this.$set(this.range, 1, value);
                }
            },
        },
    }
</script>

<style scoped>

</style>
